import type { CuratedItem, VariationComponent } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
    checkMediaIntegrity,
    firstItemOnly,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentFeatureLedeWeekend";

export default function integrityCheck({
    items,
}: VariationComponent): IntegrityStatus {
    const messages = checkItemArrayIntegrity(firstItemOnly<CuratedItem>(items));
    messages.push(
        ...checkMediaIntegrity(
            firstItemOnly<CuratedItem>(items),
            MEDIA_PRIORITY
        )
    );

    return messages;
}
